import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';

const WarningAlertBox = ({
    children,
    ...props
}: PropsWithChildren<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>>) => (
    <div
        {...props}
        className={clsx('bg-warning-light p-3 px-5 rounded-md flex items-center gap-2 mb-3', props.className)}
    >
        <WarningAmberOutlinedIcon color="warning-alt" />
        {children}
    </div>
);

export { WarningAlertBox };
